<template>
    <div 
        class="module module-gallery" 
        :class="{ 'small-gallery' : !data.full_width  }" 
    >
            <OwlCarousel :options="options" role="list">
                <li  v-for="(image, i) in data" :key="i" >
                    <WpImage  
                    :data="image" 
                    size="1536x1536" 
                    background
                    caption
                    class="wide-image"
                    placeholder
                    lazy  />
                </li>
            </OwlCarousel>
    </div>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
import OwlCarousel from '@/components/elements/OwlCarousel'

export default {
    name: 'gallery',
    props: ['data'],
    computed:{

        options() {
            const VM = this;
            return {
                items: 1,
                margin: 0,
                loop: false,
                center: false,
                nav: true,
                autoplay: false,
                mouseDrag: true,
                touchDrag: true,
                pullDrag: true,
                freeDrag: false,
                callbacks: true,
                navText: [VM.svgIcons.prevArrow, VM.svgIcons.nextArrow],
            }
        }
    },

    components:{
        WpImage,
        OwlCarousel
    },
};
</script>


